import { render, staticRenderFns } from "./SelectDeliveryModal.vue?vue&type=template&id=17581082&scoped=true&"
import script from "./SelectDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./SelectDeliveryModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectDeliveryModal.vue?vue&type=style&index=0&id=17581082&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17581082",
  null
  
)

export default component.exports